import { render, staticRenderFns } from "./EncabezadoFormulario.vue?vue&type=template&id=b485054c&scoped=true"
import script from "./EncabezadoFormulario.vue?vue&type=script&lang=js"
export * from "./EncabezadoFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b485054c",
  null
  
)

export default component.exports